import { useEffect, useRef } from 'react';

interface ZapOverlayProps {
  /** Called after the zap animation completes. */
  onComplete: () => void;
  /** If true, covers only the positioned parent (position: relative).
   *  If false (default), covers the full viewport. */
  local?: boolean;
}

/**
 * Plays a quick CRT monitor power-off animation (≈320ms),
 * then calls onComplete. Mount it; it self-destructs via callback.
 */
export function ZapOverlay({ onComplete, local = false }: ZapOverlayProps) {
  const calledRef = useRef(false);

  useEffect(() => {
    // Animation is 320ms. Call onComplete after it finishes.
    const timer = setTimeout(() => {
      if (!calledRef.current) {
        calledRef.current = true;
        onComplete();
      }
    }, 340); // slight buffer over 320ms

    return () => clearTimeout(timer);
  }, [onComplete]);

  const positionClass = local
    ? 'absolute inset-0'
    : 'fixed inset-0';

  return (
    <div
      className={`${positionClass} monitor-zap pointer-events-none`}
      style={{ zIndex: 300000, background: '#0d0208' }}
    />
  );
}
